<template>
    <div>
        <nav-bar-main></nav-bar-main> 
                
        <b-alert v-if="plantDetails != null && plantDetails.plant_type == 'basic'" show variant="warning" style="display:inline-block;width:100%">
            <banner-pro/>
        </b-alert>

        <b-alert v-if="plantDetails != null && $store.getters.isProExpired" show variant="warning" style="display:inline-block;width:100%">
            <banner-pro-expired/>
        </b-alert>
        
        <div v-if="error != null" class="alert alert-danger" role="alert">
            {{$t(error)}}
        </div>

        <Loader />
        <div v-if="plantDetails != null" class="animated fadeIn container-fluid">
            
           <b-row>
            <b-col cols="12" class="mt-4 text-center">
                <div style="display: inline-block; background-color: #fff; min-height: 200px; border-radius: 20px; padding: 40px">
                    <div style="margin: 0px; padding: 0px; text-align: center"><h2>{{$t("navbar.remotepanel")}}</h2></div>
                    <div class="panel_row"><div class="activation_led" v-bind:class="{'operating_on': isOperational}" ></div><div class="panel_content">{{$t("remotepanel.operating_status_title")}}<br/><span v-html="operationalMsg"></span></div></div>
                    <div class="panel_row"><div class="activation_led" v-bind:class="{'emergency_on': isEmergency}"></div><div class="panel_content"> {{$t("remotepanel.emergency_status_title")}}<br/><span v-html="emergencyMsg"></span></div></div>
                    <div class="panel_row"><div class="activation_led" v-bind:class="{'error_on': isInError}"></div><div class="panel_content"> {{$t("remotepanel.error_status_title")}}<span v-html="errorMsg"></span></div></div>
                    <div class="panel_disable_row">
                        <b-button variant="primary" size="lg" class="btn-pill"><i class="fa fa-1x fa-key" /> {{$t("remotepanel.disable_button")}}</b-button>
                    </div>
                </div>
            </b-col>
           </b-row>

        </div>

    </div>
</template>

<script>

import Vue from 'vue'

import NavBarMain from '@/components/NavBarMain'

import BannerProExpired from '@/components/BannerProExpired';
import BannerPro from '@/components/BannerPro';
import {showAt, hideAt} from 'vue-breakpoints';





import { mapState } from 'vuex';

export default {
    name: 'RemotePanel',
    components: {
        NavBarMain,
        Event,
        BannerPro,
        BannerProExpired,
        
        hideAt, 
        showAt,
    },
    props: ['plantId'],
    data() {
        return {
            
        }     
    
    },
    
    computed: {
        ...mapState(['loading','error','commandsPending','commandResponse']),

        rndId() {
            return Math.random();
        },
        /*tabIndex() {
            if (this.currentAmbiente != null && this.currentAmbiente.isNew) return 1;
            return 0;
        },*/
        plantDetails() {
            const plant = this.$store.state.currentPlant;
            if (plant == null){
                return null;
            } 
            if (plant.id != this.plantId) return null;

            return plant;
        },
        
        unitsDetails() {
            return this.$store.state.plantUnits;
        },
        isOperational() {
            if (this.plantDetails == null) return false;
            if (this.unitsDetails == null) return false;

            var oneOk = false;
            for (var c=0; c<this.unitsDetails.length; c++) {
                var cent = this.unitsDetails[c];
                if (cent.cu_connected) {
                    console.log("centrale " + cent.cu_id+" connessa, rest_mode=" + cent.cu_status.rest_mode_running);
                    if (cent.cu_status.rest_mode_running == 'OFF') oneOk = true;
                } else {
                    console.log("centrale " + cent.cu_id +" non connessa");
                }
            }


            return (oneOk)?true:false;
        },
        isInError() {
            if (this.plantDetails == null) return false;
            if (this.unitsDetails == null) return false;

            var oneOk = false;
            for (var c=0; c<this.unitsDetails.length; c++) {
                var cent = this.unitsDetails[c];
                if (cent.cu_connected) {
                    console.log("centrale " + cent.cu_id+" connessa, rest_mode=" + cent.cu_status.rest_mode_running);
                    if (cent.cu_status.rest_mode_running == 'ON') oneOk = true;
                    if (cent.num_lamp_error > 0) oneOk = true;
                } else {
                    console.log("centrale " + cent.cu_id +" non connessa");
                    oneOk = true;
                }
            }


            return (oneOk)?true:false;
        },
        isEmergency() {
            if (this.plantDetails == null) return false;
            if (this.unitsDetails == null) return false;

            var oneOk = false;
            for (var c=0; c<this.unitsDetails.length; c++) {
                var cent = this.unitsDetails[c];
                if (cent.cu_connected) {
                    console.log("centrale " + cent.cu_id+" connessa, emergency_mode=" + cent.cu_status.emergency_running);
                    if (cent.cu_status.emergency_running == 'ON') oneOk = true;
                } else {
                    console.log("centrale " + cent.cu_id +" non connessa");
                }
            }


            return (oneOk)?true:false;
        },
        operationalMsg() {
            if (this.plantDetails == null) return "";
            if (this.unitsDetails == null) return "";

            
            var numDisconnectedCent = 0;
            var numDisabledCent = 0;
            for (var c=0; c<this.unitsDetails.length; c++) {
                var cent = this.unitsDetails[c];
                if (cent.cu_connected) {
                    console.log("centrale " + cent.cu_id+" connessa, rest_mode=" + cent.cu_status.rest_mode_running);
                    if (cent.cu_status.rest_mode_running == 'ON') numDisabledCent++;
                } else {
                    console.log("centrale " + cent.cu_id +" non connessa");
                    numDisconnectedCent++;
                }
            }
            if (numDisconnectedCent == 0 && numDisabledCent == 0) return this.$t("remotepanel.full_operational");
            var resp = this.$t("remotepanel.system_operational");
            if (numDisconnectedCent > 0) {
                resp += "<br/>" + numDisconnectedCent + this.$t("remotepanel.disconnected_cent");
            }
            if (numDisabledCent > 0) {
                resp += "<br/>" + numDisabledCent + this.$t("remotepanel.disabled_cent");
            }
            return resp;
        },
        emergencyMsg() {
            if (this.plantDetails == null) return "";
            if (this.unitsDetails == null) return "";

            
            
            var numDisabledCent = 0;
            for (var c=0; c<this.unitsDetails.length; c++) {
                var cent = this.unitsDetails[c];
                if (cent.cu_connected) {
                    console.log("centrale " + cent.cu_id+" connessa, emergency_mode=" + cent.cu_status.emergency_running);
                    if (cent.cu_status.emergency_running == 'ON') numDisabledCent++;
                } else {
                    console.log("centrale " + cent.cu_id +" non connessa");
                    
                }
            }
            if (numDisabledCent == 0) return this.$t("remotepanel.no_emergency");
            
            var resp =  numDisabledCent + this.$t("remotepanel.emergency_cent");
            
            
            return resp;
        },
        errorMsg() {
            if (this.plantDetails == null) return "";
            if (this.unitsDetails == null) return "";

            
            var numDisconnectedCent = 0;
            var numDisabledCent = 0;
            var numErrorCent = 0;
            for (var c=0; c<this.unitsDetails.length; c++) {
                var cent = this.unitsDetails[c];
                if (cent.cu_connected) {
                    console.log("centrale " + cent.cu_id+" connessa, rest_mode=" + cent.cu_status.rest_mode_running);
                    if (cent.cu_status.rest_mode_running == 'ON') numDisabledCent++;
                    if (cent.num_lamp_error > 0) numErrorCent++;
                } else {
                    console.log("centrale " + cent.cu_id +" non connessa");
                    numDisconnectedCent++;
                }
            }
            if (numDisconnectedCent == 0 && numDisabledCent == 0 && numErrorCent == 0) return this.$t("remotepanel.no_errors");
            var resp = "";
            if (numDisconnectedCent > 0) {
                resp += "<br/>" + numDisconnectedCent + this.$t("remotepanel.disconnected_cent");
            }
            if (numDisabledCent > 0) {
                resp += "<br/>" + numDisabledCent + this.$t("remotepanel.disabled_cent");
            }
            if (numErrorCent > 0) {
                resp += "<br/>" + numErrorCent + this.$t("remotepanel.error_cent");
            }
            return resp;
        },

        
    },
    mounted() {
        console.log("RemotePanel mounted, idImpianto=" + this.plantId + ", plantDetails:" + this.plantDetails)
        if (this.error == null && this.plantDetails != null) {
            var dataReady = this.loadData();
            console.log("dataReady="+dataReady);
        } 
    },
    updated() {
        //console.log("dispositiviImpianto updated, idImpianto=" + this.plantId+", plantDetails=", this.plantDetails+ ", error:" + this.error)
        /*if (this.plantDetails == null && this.zoneDetails==null && this.zoneDetails==null && this.error == null && this.$store.state.user != null) {
            this.$store.dispatch('loadPlantZones', this.plantId)
        } */
    },
    
    watch: {
        loading(val,oldval) {
            console.log("RemotePanel loading changed:" + val+", error=" + this.error)

            if (val == false && this.error == null) {
                var dataReady = this.loadData();
                console.log("dataReady="+dataReady);
            }
            
            /*if (val == false && this.plantDetails == null && this.error == null) {
                this.$store.dispatch('loadPlantDetails', this.plantId)
            } else if (val == false && this.plantDetails != null && this.unitsDetails == null && this.error == null) {
                console.log("carico units details")
                this.$store.dispatch('loadUnitsDetails', this.plantId)
            } else if (val == false && this.$store.state.commandResponse.pending == false && this.$store.state.commandResponse.command != null) {
                console.log("devo elaborare risposta comando ", this.$store.state.commandResponse);
                
            } else if (val == false && this.plantDetails != null && this.unitsDetails != null) {
                console.log("dati pronti");
               
            }
            this.$forceUpdate();*/
        },
        unitsDetails(val,oldval) {
            console.log("aggiornato unitsDetails",val,oldval);
        },
        commandsPending(val,oldval) {
            console.log("commandsPending " + val, "configInProgress =" + this.configInProgress);   
        },
        commandResponse(val,oldval) {
            console.log("updated commandResponse:",val);
            if (val.command == 'disclaimerPhotoAccepted'&& val.pending == false) {
                this.aggiungiPianta();       
            } 
        }
    },
    methods: {
        loadData() {
            if (this.plantDetails == null) {
                this.$store.dispatch('loadPlantDetails', this.plantId)
                return false;
            } if (this.unitsDetails == null) {
                this.$store.dispatch('loadUnitsDetails', this.plantId)
                return false;
            } else {
                console.log("RemotePanel dati pronti")
                //this.$forceUpdate();
            }
            return true;
        },
        ruoloUtente(id) {
            let pusers = this.$store.state.currentPlant.plant_users;
            if (pusers == null || pusers.length == 0) return "?";
            let user = pusers.filter(function(u){
                return u.userid == id;
            });
            if (user != null && user.length > 0) 
            {
               return user[0].role;
            }
            return "?";
        },
        
       
    }
}
</script>

<style lang="scss">
    .activation_led {
        display: inline-block;
        position: absolute;
        float: left;
        width: 40px;
        height: 40px;
        margin-top: 10px;
        background: rgb(221,221,221);
        background: linear-gradient(180deg, rgba(221,221,221,1) 0%, rgba(102,102,102,1) 100%);  
        border-radius: 20px;
        border: 2px solid #000;
        margin-right: 20px;
    }
    .panel_row {
        text-align: left;
        min-height: 60px;
        margin-top: 30px;
        font-size: 20px;
        white-space: nowrap;
        border-bottom: 1px solid #ccc;
        padding-bottom: 10px;
    }
    .panel_disable_row {
        margin-top: 40px;
        margin-bottom: 20px;
    }

    

    .panel_content {
        margin-left: 60px;
    }
    .panel_row span {
        font-size: 16px;
        font-weight: bold;
    }

    .operating_on {
        background: rgb(106,249,116);
        background: linear-gradient(180deg, rgba(106,249,116,1) 0%, rgba(56,115,57,1) 100%);
    }
    .emergency_on {
        background: rgb(233,249,106);
        background: linear-gradient(180deg, rgba(233,249,106,1) 0%, rgba(224,170,11,1) 100%);
    }
    .error_on {
        background: rgb(249,204,204);
        background: linear-gradient(180deg, rgba(249,204,204,1) 0%, rgba(224,11,11,1) 100%);
    }

</style>